/* eslint-disable  react/prop-types */

import React from 'react';

const ConfettiCannonIcon = ({ width = 49, height = 50 }) => (
  <svg
    width="49"
    height="50"
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 15L1 49L34 34.791"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5563 22.6569C29.442 25.5425 31.7169 28.4427 33.0696 30.7792C33.7497 31.954 34.1671 32.9359 34.3338 33.6713C34.5135 34.4644 34.3429 34.6693 34.3345 34.6777C34.3261 34.6861 34.1213 34.8567 33.3282 34.6769C32.5928 34.5103 31.6109 34.0929 30.4361 33.4127C28.0996 32.06 25.1994 29.7852 22.3137 26.8995C19.428 24.0138 17.1532 21.1136 15.8005 18.7771C15.1203 17.6023 14.7029 16.6204 14.5363 15.885C14.3565 15.0919 14.5271 14.8871 14.5355 14.8787C14.544 14.8703 14.7488 14.6997 15.5419 14.8794C16.2773 15.0461 17.2592 15.4635 18.434 16.1436C20.7705 17.4963 23.6707 19.7712 26.5563 22.6569Z"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M7 36C9.75435 38.4114 9.28441 43 7.85666 46"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10 28C14.7475 31.8945 14.687 37.9742 12.811 43"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20 25.0044C22.2492 30.5553 20.937 36.7869 17.4994 41.9013"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M27.9748 1.49237C28.098 9.0941 25.5918 14.2016 21.4035 19.4356"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="43" cy="20" r="2" stroke="#00AED9" strokeWidth="2" />
    <circle cx="18" cy="7" r="2" stroke="#00AED9" strokeWidth="2" />
    <circle cx="11" cy="3" r="1" fill="#00AED9" />
    <circle cx="32" cy="9" r="1" fill="#00AED9" />
    <circle cx="48" cy="9" r="1" fill="#00AED9" />
    <circle cx="42" cy="31" r="1" fill="#00AED9" />
    <circle cx="46" cy="37" r="1" fill="#00AED9" />
    <circle cx="17" cy="30" r="1" fill="#00AED9" />
    <circle cx="37" cy="4" r="2" stroke="#00AED9" strokeWidth="2" />
    <path
      d="M38 39L38 45"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M33 14L33 20"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M35 42L41 42"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M30 17L36 17"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M38.7624 25.9354C35.7497 25.837 32.7574 26.7267 29.7904 28.8515"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15.4433 26.9611C14.8138 25.7205 13.9297 24.25 12.0389 22.4433"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 8L7 14"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4 11L10 11"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M43.9931 10.7383C42.5349 11.0198 40.9755 11.5046 39.1047 12.9973"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M27.4282 32.0989C28.0929 34.548 26.5166 36.9262 25.6503 37.8462"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ConfettiCannonIcon;
